import { useState, useRef, useEffect } from "react";
import { FileType } from "../types/types";
import { deleteObject, getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useAuth } from "reactfire";
import { MdDeleteOutline } from "react-icons/md";
import { Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from "@nextui-org/react";
import { Document, Thumbnail } from 'react-pdf';
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { doc, getFirestore, setDoc } from "firebase/firestore";

//file upload to firestore storage
export const FileUpload: React.FC<{ fileObj: FileType, handleUpload: (newUploadFile:FileType) => void, handleDelete: () => void }> = ({ fileObj, handleUpload, handleDelete }) => {
    const storage = getStorage();
    const firestore = getFirestore(); 
    const auth = useAuth();
    const [file, setFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [uploadedFile, setUploadedFile] = useState<FileType | null>(fileObj );

    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const [numPages, setNumPages] = useState<number>();
    const [pageNumber, setPageNumber] = useState<number>(1);

    const { id } = useParams();

    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
    }

    const downloadUrl = () => {
        if (!uploadedFile) return;
        if (uploadedFile.path === "") return; 
        return getDownloadURL(ref(storage, uploadedFile.path));
    }
    const handleFileUpload = (e: any) => {
        const file = e.target.files[0];
        setFile(file);

        const fileRef = ref(storage, `/testruns/${auth.currentUser?.uid}/${id}_${file.name}`);

        uploadBytes(fileRef, file).then(async (snapshot) => {
            const fileId = uuidv4();
            const newUploadFile: FileType = {
                id: fileId, 
                path: fileRef.fullPath,
                name: file.name,
                downloadUrl: await getDownloadURL(fileRef),
                owner: auth.currentUser?.uid || '',
                deleted: false
            }

            setDoc(doc(firestore, `files/${fileId}`), newUploadFile, { merge: true })

            setUploadedFile(newUploadFile);

            handleUpload(newUploadFile);
        });
        console.log('Uploaded a blob or file!');
    };


    const deleteUploadedFile = () => {
        if (!uploadedFile) return;
        if ('id' in uploadedFile) {
            const docRef = doc(firestore, `files/${uploadedFile.id}`);
            setDoc(docRef, { deleted: true }, { merge: true });
        }

        const fileRef = ref(storage, `${uploadedFile.path}`);
        deleteObject(fileRef).then(() => {
            // File deleted successfully
           handleDelete();
        }).catch((error) => {
            setUploadedFile(null);
            // Uh-oh, an error occurred!
        });

    }

    const handleFileUploadClick = () => {
        fileInputRef.current?.click();
    };

    useEffect(() => {
        downloadUrl()?.then((url) => {
            console.log("Download urls : ", url);
            setUploadedFile((uploadedFile) => {
                return {
                    id : uploadedFile?.id || '',
                    path: uploadedFile?.path || '',
                    name: uploadedFile?.name || '',
                    downloadUrl: url, 
                    owner: uploadedFile?.owner || '',
                    deleted: uploadedFile?.deleted || false
                };
            });
        });
    }, []);

    return (
        <div className="flex flex-row items-center">
            {uploadedFile && uploadedFile.path !== ""? (
                <div className="flex flex-row gap-4 items-center ">
                    <MdDeleteOutline size={18} onClick={deleteUploadedFile} />
                    <div onClick={onOpen}>{uploadedFile.name}</div>
                </div>
            ) : (
                <span onClick={handleFileUploadClick}>Click here to upload </span>
            )}
            <input
                ref={fileInputRef}
                type="file"
                style={{ display: "none" }}
                onChange={handleFileUpload}

            />
            <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
                <ModalContent>
                    <ModalHeader className="flex flex-col gap-1">Preview</ModalHeader>
                    <ModalBody>
                        <Document file={uploadedFile?.downloadUrl} onLoadSuccess={onDocumentLoadSuccess}>
                            <Thumbnail pageNumber={pageNumber} width={600} height={800} />
                        </Document>
                        <p>
                            Page {pageNumber} of {numPages}
                        </p>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </div>
    )
}
